/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import styled, { css } from 'styled-components';
import { brand } from '../../../js/localizations/current-locale';
import devices from '../../../js/styles/Devices';
// import style from './style';

const Section = styled.section`
  && {
    background-color: ${(props) => (props.backgroundColor === 'samblaSwirlyM' ? 'var(--link-color)' : props.backgroundColor)};
    padding: ${(props) => (props.disablePadding ? '' : (props.padding ? props.padding : '2.5rem 1rem'))};

    @media ${devices.upFromSmallDesktop} {
      ${(props) => props.swirlyM && css`
        background: url("data:image/svg+xml,%3Csvg width='44' height='23' viewBox='0 0 44 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.3283 23.0002C22.2273 23.0002 22.127 23.0002 22.026 22.9933C17.8657 22.8157 15.6896 19.2905 15.6896 15.8997C15.6896 12.4612 17.4445 9.58229 20.0263 7.55488C18.5372 6.38405 16.6874 5.75314 14.785 5.76727C6.54694 5.76727 5.43558 13.7055 5.43558 21.4708H0.597656C0.597656 14.7077 1.6857 9.77826 3.93019 6.399C6.31379 2.80532 9.96652 0.983887 14.785 0.983887C18.2124 0.983887 21.7019 2.45103 24.3668 5.00949C24.416 5.0556 24.4642 5.10248 24.5114 5.15013C26.1083 4.60363 27.7854 4.32112 29.4752 4.31396C33.4924 4.31396 37.1009 5.93634 39.6383 8.88138C42.2706 11.9386 43.6626 16.2916 43.6626 21.4708H38.8254C38.8254 13.8384 35.2426 9.09734 29.4752 9.09734C28.7955 9.09655 28.1173 9.15804 27.4491 9.28102C28.4254 11.3547 28.926 13.6162 28.9149 15.9035C28.9149 18.06 28.1594 19.9629 26.7869 21.2618C25.5857 22.3922 23.9865 23.0158 22.3283 23.0002ZM22.9866 11.323C21.4322 12.6172 20.5268 14.3042 20.5268 15.8997C20.5268 17.303 21.1656 18.1684 22.2366 18.2145C22.5723 18.2276 23.0565 18.1692 23.4428 17.8033C23.8531 17.4152 24.0785 16.7389 24.0785 15.8997C24.0769 14.4648 23.7086 12.8424 22.9866 11.323Z' fill='%23DF202D'/%3E%3C/svg%3E") no-repeat left bottom -2.2rem !important;
        background-size: 900px !important;
        background-color: #570014 !important;
      `}
    }
  }
`;

const SectionContainer = styled.div`
  && {
    ${(props) => !props.noContainer && css`
      margin-left: auto;
      margin-right: auto;
      width: 100%;

      ${() => brand === 'omalaina' && css`
        @media ${devices.smallDesktop}  {
          max-width: none !important;
        }
      `}

        @media (min-width: 540px) {
          max-width: 576px;
        }

        @media (min-width: 720px) {
          max-width: 768px;
        }

        @media (min-width: 992px) {
          max-width: 960px;
        }

        @media (min-width: 1200px) {
          max-width: 1200px;
        }
    `}
  }
`;

const SectionWrapper = ({
  children,
  settings,
  noContainer,
  padding,
  disablePadding,
}) => {
  // eslint-disable-next-line no-nested-ternary
  const backgroundColor = settings && settings.backgroundColor
    ? (settings.backgroundColor[0] === 'other' ? settings.customBackgroundColor : settings.backgroundColor[0])
    : undefined;

  const sectionID = (settings && settings.sectionId) ? settings.sectionId : null;

  return (
    <Section
      backgroundColor={backgroundColor}
      id={sectionID}
      swirlyM={backgroundColor === 'samblaSwirlyM'}
      padding={padding}
      disablePadding={disablePadding}
    >
      <SectionContainer
        noContainer={noContainer}
      >
        {children}
      </SectionContainer>
    </Section>
  );
};

SectionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  settings: PropTypes.shape({
    padding: PropTypes.string,
    backgroundColor: PropTypes.arrayOf(PropTypes.string),
    customBackgroundColor: PropTypes.string,
    fontFamily: PropTypes.arrayOf(PropTypes.string),
    sectionId: PropTypes.string,
  }),
  noContainer: PropTypes.bool,
  padding: PropTypes.string,
  disablePadding: PropTypes.bool,
};

SectionWrapper.defaultProps = {
  noContainer: false,
  settings: {},
  padding: null,
  disablePadding: false,
};

export default SectionWrapper;

export const sectionSettingsQuery = graphql`
  fragment sectionSettingsFields on AcfSectionSettings {
    padding
    backgroundColor
    customBackgroundColor
    fontFamily
    sectionId
    titlePosition
    titleColor
    titleLine
  }
`;
